import { Text } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { useIstTestsystem } from "../hooks/useAuth.js";

/**
 * Gelbes Band über dem Inhalt, wenn die Oberfläche gegen ein Testsystem läuft.
 *
 * **Wozu.** Staging und Produktion sehen identisch aus — dieselbe Oberfläche,
 * dieselben echten Kunden. Wer den falschen Reiter erwischt, merkt es erst,
 * wenn eine Änderung nicht da ankommt, wo sie hin sollte (Rückmeldung Hendrik,
 * 2026-08-20: „habe ich schon manchmal selbst vertan").
 *
 * **Was es NICHT sagt.** „Hier kannst du gefahrlos herumprobieren" — das wäre
 * falsch. Auf Staging liegen dieselben echten Kunden-, Umsatz- und
 * Beschäftigtendaten wie auf Produktion (`docs/runbooks/staging-aus-prod-neu-
 * aufbauen.md`). Das Band trennt die Systeme, es entwertet die Daten nicht.
 *
 * Nicht wegklickbar, aus demselben Grund wie beim Band der übernommenen Sicht:
 * Ein Hinweis, den man einmal wegdrückt und dann nie wieder sieht, hilft genau
 * bei der Sitzung nicht, in der man ihn braucht.
 */
export function TestsystemBanner() {
  const istTest = useIstTestsystem();
  const { t } = useTranslation();

  if (!istTest) return null;

  return (
    <div
      role="status"
      style={{
        background: "var(--mantine-color-yellow-2)",
        borderBottom: "1px solid var(--mantine-color-yellow-5)",
        padding: "6px 12px",
        textAlign: "center",
      }}
    >
      <Text size="sm" c="yellow.9" span fw={700}>
        {t("app.testsystem.titel")}
      </Text>{" "}
      <Text size="sm" c="yellow.9" span>
        {t("app.testsystem.text")}
      </Text>
    </div>
  );
}
